import { FrownOutlined, MehOutlined, SmileOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { ANSWERS } from "../../../../helpers/constants";

const AnswerWrapper = ({
  setRateOfComplete,
  questionId,
  colorId,
  answerId,
  handleAnswerClick,
  categoryData,
}) => {
  const { submittedAnswer } = useSelector((state) => state.CRRsurvey);

  const showSpinner = (smileyId) =>
    submittedAnswer?.id === questionId &&
    (categoryData?.category_id || null) === submittedAnswer?.sub_category && // check if current question and current category is submitted
    answerId === smileyId;

  return (
    <div className="response-smiley-container">
      <div
        className={`${colorId == ANSWERS.No && "red-button"} response-smiley`}
        onClick={() => {
          handleAnswerClick(ANSWERS.No);
        }}
      >
        {showSpinner(ANSWERS.No) ? (
          <Spin />
        ) : (
          <>
            <FrownOutlined className="smiley-icon" />
            No
          </>
        )}
      </div>
      <div
        className={`${
          colorId == ANSWERS.Incomplete && "yellow-button"
        } response-smiley`}
        onClick={() => {
          setRateOfComplete(1); // 1st rating by default
          handleAnswerClick(ANSWERS.Incomplete, 1);
        }}
      >
        {showSpinner(ANSWERS.Incomplete) ? (
          <Spin />
        ) : (
          <>
            <MehOutlined className="smiley-icon" />
            Incomplete
          </>
        )}
      </div>
      <div
        className={`${
          colorId == ANSWERS.Yes && "green-button"
        } response-smiley`}
        onClick={() => {
          handleAnswerClick(ANSWERS.Yes);
        }}
      >
        {showSpinner(ANSWERS.Yes) ? (
          <Spin />
        ) : (
          <>
            <SmileOutlined className="smiley-icon" />
            Yes
          </>
        )}
      </div>
    </div>
  );
};

export default AnswerWrapper;
